import type { DraftPublicationGroupState } from "@/api/clause-checklists/checklist-generation.types";
import { SharedWithGroupLabel } from "@/components/shared/SharedWithGroupLabel";
import { cn } from "@/lib/utils";

const ON_PUBLISH = "On publish";

export const DRAFT_GROUP_UNAVAILABLE = `${ON_PUBLISH}: The selected group is no longer available`;

interface IProps {
    draft: DraftPublicationGroupState;
    className?: string;
}

export const DraftPublicationGroupLabel = ({ draft, className }: IProps) => {
    switch (draft.draft_publication_group_status) {
        case "not_selected":
            return null;
        case "available":
            return (
                <SharedWithGroupLabel
                    group={draft.draft_publication_group}
                    prefix={ON_PUBLISH}
                    className={className}
                />
            );
        case "unavailable":
            return (
                <span
                    className={cn(
                        "text-destructive block min-w-0 text-xs font-medium",
                        className
                    )}
                >
                    {DRAFT_GROUP_UNAVAILABLE}
                </span>
            );
        default:
            draft satisfies never;
            return null;
    }
};
